// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2j4cz","list":"styles_list__1890m"};